export default class Occupation {
  constructor(
    occupationId,
    employmentStatusId,
    employersBusinessId,
    partTime,
    objectId,
    parentObjectId,
    parentObjectHistoryId
  ) {
    this.occupationId = occupationId;
    this.employmentStatusId = employmentStatusId;
    this.employersBusinessId = employersBusinessId;
    this.partTime = partTime;
    this.objectId = objectId;
    this.parentObjectId = parentObjectId;
    this.parentObjectHistoryId = parentObjectHistoryId;
  }
}
